import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=563bd660&scoped=true&lang=html&"
import script from "./Profile.vue?vue&type=script&lang=coffee&"
export * from "./Profile.vue?vue&type=script&lang=coffee&"
import style0 from "./Profile.vue?vue&type=style&index=0&id=563bd660&scoped=true&lang=css&"
import style1 from "./Profile.vue?vue&type=style&index=1&id=563bd660&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563bd660",
  null
  
)

component.options.__file = "Profile.vue"
export default component.exports